import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

const STRINGS = appStrings.modules.deepDives;

export type CategoryTab = Readonly<{
  value: string;
  label: string;
}>;

export const CATEGORY_TABS: CategoryTab[] = [
  { value: 'all', label: STRINGS.tabs.all },
  { value: 'high_school', label: STRINGS.tabs.highSchool },
  { value: 'college', label: STRINGS.tabs.college },
  { value: 'academic', label: STRINGS.tabs.academic },
  { value: 'career', label: STRINGS.tabs.career },
];
